import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from "./locale/i18n";
import '@mdi/font/css/materialdesignicons.css';
import Buefy from 'buefy';
import '@/styles/bulma.scss';
import { InlineSvgPlugin } from 'vue-inline-svg';

import BAG3D from '@/assets/3dbag_versions.json';

Vue.use( InlineSvgPlugin );
Vue.use( Buefy );

Vue.config.productionTip = false;




var tileCounter = {};
window.targetProxy = new Proxy(tileCounter, {
  set: function (target, key, value) {
    //   console.log(`${key} set to ${value}`);
	  switch(value) {
		case 5:
			NProgress.set(0.2);
			break;
		case 4:
			NProgress.set(0.3);
			break;
		case 3:
			NProgress.set(0.6);
			break;
		case 2:
			NProgress.set(0.8);
			break;
		case 1:
			NProgress.set(0.9);
			break;		
		case 0:
			NProgress.done();	
			break;
	  }
      target[key] = value;
      return true;
  }
});

window.targetProxy.count = 0; 

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    let [resource, config ] = args;
	if (resource.indexOf("b3dm") > -1) {
		window.targetProxy.count++;
	}
    const response = await originalFetch(resource, config);	
    return response;
};


new Vue( {
	data: BAG3D,
	render: h => h( App ),
	router,
	i18n,
	template: '<App/>',
} ).$mount( '#app' );

i18n.locale = 'nl';